module.exports = __webpack_public_path__ + "h5/img/defaultavatar1.36e4e64e.png";